import { Button, ButtonProps, Transition } from "@mantine/core";
import React, { useState } from "react";

import style from "./GlowButton.module.scss";

interface ExtendedButtonProps extends ButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const GlowButton = (props: ExtendedButtonProps) => {
  const { onClick, className, ...otherProps } = props;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Transition
      mounted={true}
      transition="fade"
      duration={300}
      timingFunction="ease-in-out"
    >
      {(styles) => (
        <Button
          variant="gradient"
          gradient={{ from: "cyan", to: "grape", deg: isHovered? 100: 135 }}
          className={`${style.glowAnimation} ${className || ""}`}
          onClick={onClick ? (e) => onClick(e) : undefined}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            ...styles,
            boxShadow: isHovered
              ? '0 0 20px rgba(6, 182, 212, 0.5), 0 0 40px rgba(168, 85, 247, 0.3)'
              : '0 0 10px rgba(6, 182, 212, 0.2)',
            transition: 'box-shadow 0.3s ease-in-out',
          }}
          {...otherProps}
        />
      )}
    </Transition>
  );
};

export default GlowButton;
